module.exports = __webpack_public_path__ + "media/images/dollar_sign-eb3cfc72b7a1ef5cf28d4b2009cf6c43.svg";